/* eslint-disable no-param-reassign,no-unused-vars */
import Vue from 'vue'

const AppInsightsPlugin = {
  install(/* vue */) {
  },
};

export default AppInsightsPlugin;
